// specialtiesSlice.ts
import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { ISpecialty, ISpecialtyInitialState } from "./specialtiesModal";
import {
  activeInactiveSpecialty,
  createSpecialty,
  deleteSpecialty,
  getAllActiveSpecialties,
  getAllSpecialties,
  getSpecialtyByID,
  specialtyImageUpload,
  updateSpecialty,
} from "./services/specialties.service";

const initialState: ISpecialtyInitialState = {
  loading: false,
  formLoading: false,
  error: "",
  SpecialtyID: null,
  SpecialtyList: [],
  SpecialtyDetail: {
    ID: null,
    Title: "",
    Remarks: "",
    Image: "",
    IsActive: 1,
  },
};

const specialtySlice = createSlice({
  name: "specialty",
  initialState,
  reducers: {
    clearSpecialtyDetails: (state) => {
      state.SpecialtyDetail = initialState.SpecialtyDetail;
    },
    setSpecialtyID: (state, action) => {
      state.SpecialtyID = action.payload;
    },
    clearSpecialtyID: (state) => {
      state.SpecialtyID = initialState.SpecialtyID;
    },
  },
  extraReducers: (builder) => {
    // Get All Specialties
    builder.addCase(getAllSpecialties.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(
      getAllSpecialties.fulfilled,
      (state, action: PayloadAction<ISpecialty[]>) => {
        state.loading = false;
        state.SpecialtyList = action.payload || [];
      },
    );
    builder.addCase(getAllSpecialties.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
      state.SpecialtyList = [];
    });

    // Create Specialty
    builder.addCase(createSpecialty.pending, (state) => {
      state.formLoading = true;
      state.error = "";
    });
    builder.addCase(createSpecialty.fulfilled, (state) => {
      state.formLoading = false;
    });
    builder.addCase(createSpecialty.rejected, (state, action) => {
      state.formLoading = false;
      state.error = action.error.message || "Something went wrong";
    });

    // Update Specialty
    builder.addCase(updateSpecialty.pending, (state) => {
      state.formLoading = true;
      state.error = "";
    });
    builder.addCase(updateSpecialty.fulfilled, (state) => {
      state.formLoading = false;
    });
    builder.addCase(updateSpecialty.rejected, (state, action) => {
      state.formLoading = false;
      state.error = action.error.message || "Something went wrong";
    });

    // Delete Specialty
    builder.addCase(deleteSpecialty.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(deleteSpecialty.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(deleteSpecialty.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });

    // Get Specialty By ID
    builder.addCase(getSpecialtyByID.pending, (state) => {
      state.formLoading = true;
      state.error = "";
    });
    builder.addCase(getSpecialtyByID.fulfilled, (state, action: any) => {
      state.formLoading = false;
      state.SpecialtyDetail = action.payload;
    });
    builder.addCase(getSpecialtyByID.rejected, (state, action) => {
      state.formLoading = false;
      state.SpecialtyDetail = initialState.SpecialtyDetail;
      state.error = action.error.message || "Something went wrong";
    });

    // Get All Active Specialties
    builder.addCase(getAllActiveSpecialties.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(
      getAllActiveSpecialties.fulfilled,
      (state, action: PayloadAction<ISpecialty[]>) => {
        state.loading = false;
        state.SpecialtyList = action.payload || [];
      },
    );
    builder.addCase(getAllActiveSpecialties.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
      state.SpecialtyList = [];
    });

    // Active/Inactive Specialty
    builder.addCase(activeInactiveSpecialty.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(activeInactiveSpecialty.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(activeInactiveSpecialty.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });

    // Image Upload
    builder.addCase(specialtyImageUpload.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(specialtyImageUpload.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(specialtyImageUpload.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });
  },
});

export const { clearSpecialtyDetails, clearSpecialtyID, setSpecialtyID } =
  specialtySlice.actions;
export default specialtySlice.reducer;
